<template>
  <div class="main">
    <!--<img src="../img/logo.jpg" class="logo"/>-->
    <img src="../img/indexbg.jpg" width="100%"/>
    <div class="con">
      <div class="lcon">
        <h1>公司简介</h1>
        <p>{{text2}}，目前是京东最佳战略合作伙伴之一。致力于科技、互联网+传统相关业务模式，基于互联网思维，利用大数据完成用户精准获取与推送，为B端客户、C端用户提供服务。</p>
        <p>覆盖的商户及品牌有中粮集团、蒙牛、奥妙、稻香村、迪士尼、西门子、南极人、浪莎、阿迪达斯、德芙、苏泊尔、维达、OPPO、百年栗园、新疆特产、原始人、网易严选等千余个。</p>
        <p>{{text1}}公司本着“跨界+科技创新+生态共赢”的理念，致力为客户、用户提供一流的推广解决方案和服务，用良好的生态共赢思维与用户体验创新方式竭诚为大家服务！</p>
      </div>
      <div class="rcon">
        <div class="col">
          <img src="../img/dcode3.jpg" class="dcode"/>
          <p>扫码下载APP</p>
        </div>
        <div class="col">
          <img src="../img/dcode1.jpg" class="dcode"/>
          <p>扫码查看小程序</p>
        </div>
        <div class="col">
          <img src="../img/dcode2.jpg" class="dcode"/>
          <p>扫码关注公众号</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dcode: '',
      text1: '',
      text2: ''
    }
  },
  methods: {
  },
  mounted: function () {
    let path = window.location.href;
    console.log(path);
    if(path.indexOf('qunshaidan') !== -1){
      this.text1 = '京淘';
      this.text2 = '京淘（北京）科技有限公司'
    }else{
      this.text1 = '运多多';
      this.text2 = '北京运多多网络科技有限公司'
    }
    this.$layer.dialog({
      title: ['声明','background:#c00;color:#fff'], // 第一个是标题内容  第二个是标题栏的style(可以为空)
      content: '<p style="text-align: left">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近期我公司接到多名用户举报，有不法分子打着我公司“' + this.text2 + '”的名义进行网络诈骗，其中之一行为是让用户在京东等电商网站上刷单得高额返利（或返佣）的操作，通过此方法诱引参与刷单用户上当消费、汇款等，最终导致用户财产损失。</p><p style="text-align: left">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本公司声明，我们从未在网络上以短信或以任何形式联系用户进行“充值”等此类型操作！“' + this.text1 + '商城”、“' + this.text1 + '优惠”等app或公众号或小程序也并非我公司的产品！希望广大网友谨防上当受骗，遇到此类诈骗请尽快联系您所在当地警方，避免财产损失！</p><p style="text-align: left">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们是一家正规且合规的科技公司，相关业务也符合国家法律法规制度，并受到相关部门监管。对于不法分子盗取我公司名义及恶意泄露我公司执照等行为给予严正的谴责，并保留追究当事人法律责任的权利，解决对我公司的不良侵害！</p><p style="text-align: right">特此声明</p><p style="text-align: right">' + this.text2 + '</p><p style="text-align: right">2020年11月16日</p>',
      contentClass: 'className',
      btn: ['确定'],
      //   time: 2000
    })
      .then(function (res){
        this.$layer.close();
        console.log(position)
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {}
  .logo{width: 161px; height: 60px; position: absolute; left: -3px; top: -3px; border-radius: 0 0 20px 0; border: 2px solid #fff}
  .con {width: 1200px; height: 300px; margin: 0 auto; margin-top: 50px}
  .con .lcon {float: left; width: 500px; font-size: 14px; line-height: 24px; color: #666}
  .con .lcon h1 {font-size: 18px; line-height: 40px; color: #333}
  .con .rcon {float: right; width: 580px; line-height: 0; margin-top: 40px}
  .con .rcon .col {float: left; margin-left: 30px}
  .con .rcon .dcode {width: 160px; height: 160px}
  .con .rcon p {line-height: 30px; font-size: 14px; text-align: center}
</style>



// WEBPACK FOOTER //
// src/components/home.vue